import { render, staticRenderFns } from "./department.vue?vue&type=template&id=7f2055e4&scoped=true"
import script from "./department.vue?vue&type=script&lang=js"
export * from "./department.vue?vue&type=script&lang=js"
import style0 from "./department.vue?vue&type=style&index=0&id=7f2055e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2055e4",
  null
  
)

export default component.exports